import { FeatureFlags, useFeatureFlag } from '~/utils/featureflags';

import { useScanDetection } from '../hooks/useScanDetection';

const ScanDetectionListener = () => {
  useScanDetection();

  return null;
};

export const ScanDetectionMonitor = () => {
  const isScanDetectionEnabled =
    useFeatureFlag(FeatureFlags.QUICKPACK_SCAN_TO_PRINT)?.enabled ?? false;

  if (!isScanDetectionEnabled) return null;

  return <ScanDetectionListener />;
};
